import http from '@/common/request/axios';

export const liveopsPointService = {
    item: {
        list({ rewardType, offset, limit }: any) {
            return http.doGet('admin/liveops', { rewardType, offset, limit });
        },

        get(itemId: number) {
            return http.doGet('admin/liveops/' + itemId);
        },

        create(
            cloneId: number,
            name: string,
            rewardType: number,
            type: number,
            betCosts: string,
            startTime: number,
            closeTime: number,
            endTime: number,
            image: unknown,
            icon: unknown
        ) {
            return http.doPost(
                'admin/liveops/',
                { cloneId, name, rewardType, type, betCosts, startTime, closeTime, endTime },
                { image, icon }
            );
        },

        update(
            itemId: number,
            name: string,
            rewardType: number,
            type: number,
            betCosts: string,
            startTime: number,
            closeTime: number,
            endTime: number,
            image: unknown,
            icon: unknown
        ) {
            return http.doPut(
                'admin/liveops/' + itemId,
                { name, rewardType, type, betCosts, startTime, closeTime, endTime },
                { image, icon }
            );
        },

        updateContent(
            itemId: number,
            name: string,
            betCosts: string,
            type: number,
            endTime: number,
            image: unknown,
            icon: unknown
        ) {
            return http.doPut(
                'admin/liveops/' + itemId + '/content',
                { name, betCosts, type, endTime },
                { image, icon }
            );
        },

        remove(itemId: number) {
            return http.doDelete('admin/liveops/' + itemId);
        },

        enable(itemId: number) {
            return http.doPut('admin/liveops/' + itemId + '/enable');
        },

        disable(itemId: number) {
            return http.doPut('admin/liveops/' + itemId + '/disable');
        },

        getText(itemId: number, locale: string) {
            return http.doGet('admin/liveops/' + itemId + '/text/' + locale);
        },

        updateText(itemId: number, locale: string, title: string, description: string) {
            return http.doPut('admin/liveops/' + itemId + '/text/' + locale, {
                title,
                description
            });
        },

        removeText(itemId: number, locale: string) {
            return http.doDelete('admin/liveops/' + itemId + '/text/' + locale);
        }
    },

    reward: {
        getLinkableItems() {
            return http.doGet('admin/liveops/reward/linkable');
        }
    },

    milestone: {
        list({ itemId }: any) {
            return http.doGet('admin/liveops/milestone', { itemId });
        },

        remove(itemId: number, milestone: number) {
            return http.doDelete('admin/liveops/milestone', { itemId, milestone });
        },

        add(itemId: number, pointCap: number, feature: number, data: number, quantity: number) {
            return http.doPut('admin/liveops/milestone', {
                itemId,
                pointCap,
                feature,
                data,
                quantity
            });
        }
    },

    leaderboard: {
        list({ itemId }: any) {
            return http.doGet('admin/liveops/leaderboard', { itemId });
        },

        remove(itemId: number, leaderboardId: number) {
            return http.doDelete('admin/liveops/leaderboard', { itemId, leaderboardId });
        },

        add(itemId: number, toRank: number, feature: number, data: number, quantity: number) {
            return http.doPut('admin/liveops/leaderboard', { itemId, toRank, feature, data, quantity });
        }
    }
};
